import React from 'react';
import { Box, PageContent, Text } from 'bumbag';
import _get from 'lodash/get';

import LayoutPage from 'legacy/components/checkout/layout/Page';
import RedirectCountdown from 'legacy/components/checkout/RedirectCountdown';
import CompletedTransactionMessage from 'legacy/components/CompletedTransactionMessage';
import { getKeyFromQueryParams } from 'legacy/utils/router';

import { TRANSACTION_ACTIONS } from '../../constants';
type Props = {};
type State = {
  error: Record<string, any>;
  returnUrl?: string;
};
export default class Failed extends React.PureComponent<Props, State> {
  state = {
    error: JSON.parse(getKeyFromQueryParams('error') || '{}'),
    returnUrl: getKeyFromQueryParams('returnUrl'),
  };
  render = () => {
    const { error, returnUrl } = this.state;
    return (
      <LayoutPage title="Approval failed">
        <PageContent breakpoint="checkout">
          <CompletedTransactionMessage type={TRANSACTION_ACTIONS.FAILURE} />
          <Box marginBottom="major-1">
            {error.message && (
              <Box marginTop="major-1">
                <Text fontWeight="semibold">Details</Text>:<br />
                {error.message}
              </Box>
            )}
            {_get(error, 'errors.length', 0) > 0 && (
              <Box>
                {/* @ts-expect-error TS(7006): Parameter 'error' implicitly has an 'any' type. */}
                {_get(error, 'errors', []).map((error, i) => (
                  /* eslint-disable react/no-array-index-key */
                  <Text key={i}>
                    - {error.message}
                    <br />
                  </Text>
                ))}
              </Box>
            )}
          </Box>
          {returnUrl && (
            <Box textAlign="center">
              <RedirectCountdown redirectUrl={returnUrl} />
            </Box>
          )}
        </PageContent>
      </LayoutPage>
    );
  };
}
